export default "/images/img_13.png?cf988968945146f0157d7b9ed497d83a";